import React, { useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Btn, Input, Field } from "@/components/ui-kit";
import { AuthShell, Notice } from "@/components/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setMsg({ tone: "err", text: "Passwords do not match" }); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, new_password: pw });
      setMsg({ tone: "ok", text: data.message, done: true });
    } catch (err) {
      setMsg({ tone: "err", text: apiError(err.response?.data?.detail) });
    }
    setBusy(false);
  };

  return (
    <AuthShell title="Choose New Password" subtitle="At least 8 characters.">
      {!token ? (
        <Notice tone="err" data-testid="reset-message">This reset link is missing its token. Request a new one.</Notice>
      ) : msg?.done ? (
        <div className="space-y-3">
          <Notice data-testid="reset-message">{msg.text}</Notice>
          <Link to="/login"><Btn size="lg" className="w-full" data-testid="reset-go-login">Sign in</Btn></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <Field label="New Password" required>
            <Input data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} />
          </Field>
          <Field label="Confirm Password" required>
            <Input data-testid="reset-password-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required minLength={8} />
          </Field>
          <Btn type="submit" size="lg" className="w-full" disabled={busy} data-testid="reset-submit">
            {busy ? "Saving…" : "Set password"}
          </Btn>
          {msg && <Notice tone={msg.tone} data-testid="reset-message">{msg.text}</Notice>}
        </form>
      )}
    </AuthShell>
  );
}
